module.exports = __webpack_public_path__ + "static/bg-cart-469ba1d4eaad8c8598657e56e6b5c42c.png";